export const sortQueryParamsByKey = (obj: {
	[key: string]: string;
}): { [key: string]: string } => {
	if (!obj) return {};

	const keys = Object.keys(obj);
	keys.sort();

	const sortedObj: { [key: string]: string } = {};
	keys.forEach((key) => {
		sortedObj[key] = obj[key];
	});

	return sortedObj;
};

export const queryParamsToObject = (queryParams: string | undefined) => {
	if (!queryParams) return;

	return queryParams.split('&').reduce((acc: { [key: string]: string }, param) => {
		const [key, value] = param.split('=');
		acc[key] = value;

		return acc;
	}, {});
};
